import React from "react";
import { Play, CalendarCheck, ShieldCheck, Cpu } from "@phosphor-icons/react";
import { useI18n } from "../../i18n/I18nContext";

const VIDEOS_RU = [
  {
    src: "https://rutube.ru/play/embed/3bcbcfa4362233a496378a19b80d833b/",
    title: "InBoost AI Engine — обзор платформы",
    label: "Обзор",
    testid: "video-1",
  },
  {
    src: "https://rutube.ru/play/embed/7551871a26822f5a956ca38601d185b2/",
    title: "InBoost AI Engine — техническая демонстрация",
    label: "Демонстрация",
    testid: "video-2",
  },
];

export const Videos = ({ onDemo }) => {
  const { isEn, t } = useI18n();

  return (
    <section id="videos" data-testid="videos-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
              {t.videos.sectionNum}
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              {t.videos.headlinePart1}{" "}
              <span className="text-brand-cyan">{t.videos.headlinePart2}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 self-end">
            <p className="text-muted text-sm leading-relaxed">
              {t.videos.desc}
            </p>
          </div>
        </div>

        {isEn ? (
          /* Global English Showcase Card */
          <div
            data-testid="videos-en-showcase"
            className="glass-strong rounded-3xl p-8 sm:p-12 relative overflow-hidden"
          >
            <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-brand/20 blur-[100px]" />
            <div className="relative grid lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-7">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-cyan/10 border border-brand-cyan/30 mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-4">
                  <Cpu size={14} weight="bold" /> Architecture Tour & Workload Profiling
                </div>
                <h3 className="font-heading font-bold text-2xl sm:text-3xl tracking-tight mb-3">
                  {t.videos.walkthroughTitle}
                </h3>
                <p className="text-muted text-base leading-relaxed mb-6 max-w-xl">
                  {t.videos.walkthroughDesc}
                </p>
                <div className="flex flex-wrap gap-4 items-center">
                  <button
                    onClick={onDemo}
                    data-testid="videos-en-demo-btn"
                    className="btn-primary rounded-lg px-6 py-3.5 font-semibold inline-flex items-center gap-2"
                  >
                    <CalendarCheck size={18} weight="bold" /> {t.videos.ctaSchedule}
                  </button>
                  <div className="flex items-center gap-2 text-xs mono text-muted">
                    <ShieldCheck size={16} className="text-brand-cyan" />
                    Production Cluster Simulations under NDA
                  </div>
                </div>
              </div>

              <div className="lg:col-span-5">
                <div className="rounded-2xl bg-ink/90 border border-ink-text/10 p-6 space-y-4 font-mono text-xs">
                  <div className="flex items-center justify-between pb-3 border-b border-ink-text/10 text-brand-cyan">
                    <span>DCGM TELEMETRY STREAM</span>
                    <span className="w-2 h-2 rounded-full bg-success animate-pulse" />
                  </div>
                  <div className="text-muted-deep space-y-2">
                    <div className="flex justify-between">
                      <span>Topology:</span>
                      <span className="text-ink-text">8x H100 SXM5 · NVLink v4</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Baseline Util:</span>
                      <span className="text-[#E11D48]">34.2% (Standard K8s)</span>
                    </div>
                    <div className="flex justify-between">
                      <span>InBoost Policy:</span>
                      <span className="text-brand-cyan">84.8% (CEI: 0.94, ZCR: 0.08)</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Memory Defrag:</span>
                      <span className="text-success">+42 GB / node recovered</span>
                    </div>
                  </div>
                  <div className="pt-2 text-[10px] text-muted text-center border-t border-ink-text/10">
                    Live mathematical bipartite scheduling in 1.4ms
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          /* Russian Rutube Embeds */
          <div className="grid md:grid-cols-2 gap-6">
            {VIDEOS_RU.map((v) => (
              <div
                key={v.testid}
                data-testid={v.testid}
                className="group glass rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="flex items-center justify-between px-5 py-3 border-b border-ink-text/8">
                  <div className="flex items-center gap-2">
                    <Play size={14} weight="fill" className="text-brand-cyan" />
                    <span className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan">
                      {v.label}
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
                    <span className="mono text-[10px] text-muted">RUTUBE</span>
                  </div>
                </div>
                <div className="relative aspect-video bg-[#0A0F1E]">
                  <iframe
                    src={v.src}
                    title={v.title}
                    className="absolute inset-0 w-full h-full"
                    style={{ border: "none" }}
                    allow="clipboard-write; autoplay"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Videos;
